import React, { useEffect } from 'react'
import Modal from 'react-modal'

const TeamInfoModal = (props) => {
    const [modalIsOpen, setIsOpen] = React.useState(false);
    const roles = ["🏃‍♂️逃走", "👹鬼", "待機", "無敵"];
    const [usingCard, setUsingCard] = React.useState(null);
    const [waitingCard, setWaitingCard] = React.useState(null);

    useEffect(() => {
        // console.log(props.isOpen);
        setIsOpen(props.isOpen);

        if(props.team && props.team.usingCard) {
            const date = new Date();
            const limitDate = new Date(props.team.usingCard.limit);
            const waitingLimit = props.team.usingCard ? new Date(props.team.usingCard.waitingLimit) : null;

            if(date <= limitDate) {
                if(waitingLimit && date <= waitingLimit) {
                    setWaitingCard(props.team.usingCard.name);
                    setUsingCard(null);
                } else {
                    setWaitingCard(null);
                    setUsingCard(props.team.usingCard.name);
                }
            }
        }
    }, [props.isOpen, props.team]);

    const customStyles = {
        overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.3)",
            zIndex: 1000,
        },
        content: {
          top: '60px',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, 0%)',
          boxShadow: '3px 3px 10px rgba(0, 0, 0, 0.2)',
          minWidth: '320px',
          maxWidth: '85%',
          borderRadius: '10px',
        },
    };

    // dateに現在時刻が近ければ、「昨日」や「5分前」みたいな表示に変換
    const formatTime = (date) => {
        const now = new Date();
        const diff = now - date;
        if (diff < 60000) {
            return `${Math.floor(diff / 1000)}秒前`;
        } else if (diff < 3600000) {
            return `${Math.floor(diff / 60000)}分前`;
        } else if (diff < 86400000) {
            return `${Math.floor(diff / 3600000)}時間前`;
        } else if (diff < 172800000) {
            return '昨日' + date.toLocaleTimeString();
        } else {
            return date.toLocaleString();
        }
    }

  return (
    <Modal
        contentLabel="チーム情報"
        style={customStyles}
        isOpen={modalIsOpen}
    >
        <h2 className='text-2xl mb-2 text-purple-700 me-8'>チーム情報</h2>
        <button onClick={() => props.onClose()} className='absolute top-4 end-4 text-xl text-gray-500'><i className='bi bi-x-lg'></i></button>

        <hr />
        
        {props.team && (
            <div className='my-3'>
                <h1 className='text-xl mb-2'><i className='bi bi-people-fill me-2' style={{color: props.team.color}}></i>{props.team.name}</h1>
                {
                    usingCard && (
                        <div className='bg-purple-100 text-purple-700 text-center rounded-md p-2 mb-2'>
                            <i className='bi bi-collection me-2'></i>{usingCard}
                        </div>
                    )
                }

                { waitingCard && (
                    <div className='bg-purple-100/50 text-purple-700/50 text-center rounded-md p-2 mb-2'>
                        <div>
                            <i className='bi bi-hourglass-split me-2 text-red-600/80'></i>{waitingCard}
                        </div>
                        <div className='text-sm text-gray-500 tracking-widest'>待機中…</div>
                    </div>
                )}

                {
                    props.team.retired && (
                        <div className='bg-red-100 text-red-600 text-center rounded p-2 mb-2'>
                            <i className='bi bi-exclamation-triangle-fill me-2'></i>リタイア
                        </div>
                    )
                }

                <div className='grid grid-cols-2 mb-2'>
                    <div>
                        <h3 className='text-gray-500 mb-1'>役</h3>
                        <div className='text-lg'>{roles[props.team.role]}</div>
                    </div>

                    <div>
                        <h3 className='text-gray-500 mb-1'>スコア</h3>
                        <div className='text-lg font-medium text-lime-600'><i className='bi bi-coin me-2 text-yellow-500'></i>{props.team.score} pt</div>
                    </div>
                </div>

                {
                    props.location && (
                        <div className='mb-2'>
                            <h3 className='text-gray-500 mb-1'>位置情報</h3>
                            <div className='text-base ms-2'><i className='bi bi-clock-history me-2'></i>{formatTime(new Date(props.location.time))}</div>
                        </div>
                    )
                }
                
                <div>
                    <h3 className='text-gray-500 mb-1'>メンバー</h3>

                    <div className='flex gap-2'>
                        {
                            props.team.members && props.team.members.map((memberId, index) => (
                                <div key={index} className='rounded border p-1 inline-block'>
                                    <span>{props.members?.[memberId]?.name}</span>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        )}
        
    </Modal>
  )
}

export default TeamInfoModal